import {ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';

const {primaryColorButton} = getLayoutDescriber();

export function disclaimerScreenStyle(): {
  buttonContainer: ViewStyle;
  buttonView: ViewStyle;
} {
  return {
    buttonContainer: {
      minHeight: Styles.Heights.touchTargetHeight1 - 2,
      width: '100%',
    },
    buttonView: {
      backgroundColor: primaryColorButton(),
      width: '100%',
    },
  };
}

export default {
  disclaimerScreenStyle,
};
